const INVITE_CODE_KEY = "inviteCode_postSignup";
const INVITE_CODE_EXPIRY_KEY = "inviteCode_expiry";
const INVITE_ORIGIN_MARKER_KEY = "inviteOrigin_postSignup";
const INVITE_ORIGIN_MARKER_EXPIRY_KEY = "inviteOrigin_expiry";
const EXPIRY_TTL_MS = 1000 * 60 * 15; // 15 minutes

export const inviteCodeStorage = {
  setForPostSignup(code: string): void {
    localStorage.setItem(INVITE_CODE_KEY, code);
    localStorage.setItem(
      INVITE_CODE_EXPIRY_KEY,
      String(Date.now() + EXPIRY_TTL_MS)
    );
  },

  setInviteOriginMarker(code: string): void {
    localStorage.setItem(INVITE_ORIGIN_MARKER_KEY, code);
    localStorage.setItem(
      INVITE_ORIGIN_MARKER_EXPIRY_KEY,
      String(Date.now() + EXPIRY_TTL_MS)
    );
  },

  getAndClear(): string | null {
    const code = localStorage.getItem(INVITE_CODE_KEY);
    const expiry = localStorage.getItem(INVITE_CODE_EXPIRY_KEY);
    localStorage.removeItem(INVITE_CODE_KEY);
    localStorage.removeItem(INVITE_CODE_EXPIRY_KEY);
    if (!code) return null;
    if (expiry && Date.now() > Number(expiry)) return null;
    return code;
  },

  clear(): void {
    localStorage.removeItem(INVITE_CODE_KEY);
    localStorage.removeItem(INVITE_CODE_EXPIRY_KEY);
  },

  getAndClearInviteOriginMarker(): string | null {
    const code = localStorage.getItem(INVITE_ORIGIN_MARKER_KEY);
    const expiry = localStorage.getItem(INVITE_ORIGIN_MARKER_EXPIRY_KEY);
    localStorage.removeItem(INVITE_ORIGIN_MARKER_KEY);
    localStorage.removeItem(INVITE_ORIGIN_MARKER_EXPIRY_KEY);
    if (!code) return null;
    if (expiry && Date.now() > Number(expiry)) return null;
    return code;
  },

  clearInviteOriginMarker(): void {
    localStorage.removeItem(INVITE_ORIGIN_MARKER_KEY);
    localStorage.removeItem(INVITE_ORIGIN_MARKER_EXPIRY_KEY);
  },
};
